export default class Faq {
    constructor() {
        this.sections = document.querySelectorAll('.component-faq');
        this.ready();
    }
    
    ready() {
        
        this.sections.forEach(section => {
            
            const allQuestions = section.querySelectorAll('.faq-item')
            allQuestions.forEach(question => {
                const questionTitle = question.querySelector('.title')
                questionTitle.addEventListener('click', () => {
                    question.classList.toggle('active')
                })
            })

        })

    }
    
}

if (document.querySelector('.component-faq')) {
    new Faq();
}